import { useSnackbar } from 'notistack';

import { GeneratorOutput } from './snackbars.types.tsx';

export function useSnackbarFromGenerated(): { enqueueSnackbarFromGenerated: (generated: GeneratorOutput) => void } {
  const { enqueueSnackbar } = useSnackbar();

  return {
    enqueueSnackbarFromGenerated(generated: GeneratorOutput) {
      enqueueSnackbar(generated.message, generated.options);
    },
  };
}
